import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "/vercel/path0/components/layout/site-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AgentModelSection"] */ "/vercel/path0/components/tech-lab/agent-model-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfrastructureSection"] */ "/vercel/path0/components/tech-lab/infrastructure-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformsSection"] */ "/vercel/path0/components/tech-lab/platforms-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TechLabCTA"] */ "/vercel/path0/components/tech-lab/tech-lab-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TechLabHero"] */ "/vercel/path0/components/tech-lab/tech-lab-hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingNav"] */ "/vercel/path0/components/ui/FloatingNavbar.tsx");
